import Image from "next/image";
import Link from "next/link";
import CPUIcon from "@/images/cpu-icon.svg";
import { useTranslation } from "next-i18next";

export default function SeoPageAudience({ seoPage }) {
  const { t } = useTranslation();
  const section = seoPage?.audience_section;

  if (!section) return null;

  const items = section.cards?.length ? section.cards : section.items ?? [];

  if (!items.length) return null;

  return (
    <section className="py-[80px] md:py-[100px]">
      <div className="max-w-[90%] mx-auto">
        <span className="inline-flex min-w-[140px] h-[28px] px-2 items-center justify-center rounded-full bg-[#DDECFF] text-[12px] font-[600] tracking-[0.08em] uppercase">
          <span className="bg-clip-text text-transparent bg-gradient-to-b from-[#091F59] to-[#1A3884]">
            {section.label ?? section.badge ?? "KİM ÜÇÜNDÜR?"}
          </span>
        </span>

        <h2 className="mt-[16px] text-[#0A0A0A] text-[28px] md:text-[36px] font-[600] leading-[120%]">
          {section.heading ?? section.title}
        </h2>

        {section.subtitle && (
          <p className="mt-[12px] text-[#6A7282] text-[16px] leading-[140%]">{section.subtitle}</p>
        )}

        <div className="mt-[24px] grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[12px] md:gap-[20px]">
          {items.map((item, index) => (
            <article
              key={`${item.title}-${index}`}
              className="h-full rounded-[16px] border border-[#E9ECF0] bg-[#F5F7FA] p-[24px] flex flex-col"
            >
              <Image src={CPUIcon} alt="CPU Icon" width={36} height={36} />

              <h3 className="mt-[12px] min-h-auto md:min-h-[56px] text-[#0A0A0A] text-[18px] font-[700] leading-[130%]">
                {item.title}
              </h3>

              <p className="mt-[20px] md:mt-0 text-[#6A7282] text-[14px] font-[400]">{item.description}</p>

              <Link href={item.cta_link ?? "/apply"} className="pt-[12px] flex justify-center">
                <button className="h-[40px] w-[220px] rounded-full border border-main-pink bg-main-pink text-white text-[14px] font-[500] transition duration-300 hover:bg-white hover:text-main-pink">
                  {item.cta_text ?? t("seo-page.apply-now")}
                </button>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
